import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../../constants/common'
import { formatDateToApi } from '../../../utils/date'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../Entity'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'
import { TASK_FORM_DEADLINE_FIELD_NAME } from '../TaskForm'

import {
  TASK_EDIT_DEADLINE_FIELDS_INITIAL_VALUES,
  TASK_EDIT_DEADLINE_FORM_ACTION_TYPES,
} from './TaskEditDeadlineModal.constants'

export function getTaskEditDeadlineActionTypes(
  availableTypes = TASK_EDIT_DEADLINE_FORM_ACTION_TYPES
) {
  return Object.values(getEntityActionTypeSelectOptions()).filter(item =>
    availableTypes.includes(item.value)
  )
}

export function getTaskEditDeadlineValidationSchema() {
  return Yup.object({
    [TASK_FORM_DEADLINE_FIELD_NAME]: Yup.date()
      .nullable()
      .when(FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME, {
        is: actionType => !isRemoveAllEntityActionType(actionType),
        then: schema => schema.required(true),
      }),
  })
}

export function getTaskEditDeadlinePayload(values, timezone) {
  return values[TASK_FORM_DEADLINE_FIELD_NAME]
    ? {
        [TASK_FORM_DEADLINE_FIELD_NAME]: formatDateToApi(
          values[TASK_FORM_DEADLINE_FIELD_NAME],
          timezone
        ),
      }
    : EMPTY_OBJECT
}

export function getTaskEditDeadlineInitialValues() {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...TASK_EDIT_DEADLINE_FIELDS_INITIAL_VALUES,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
  }
}
